
import { useState } from 'react';

const landCostData = [
  { parcel: '1302', area: 766.9, price: 25070000, total: 192.3, ownership: '이종훈 (단독)', landUse: '주유소용지' },
  { parcel: '1302-1', area: 2291.4, price: 23350000, total: 535.0, ownership: '집합건물 (다수)', landUse: '대지' },
  { parcel: '1302-2', area: 1689.9, price: 20880000, total: 352.8, ownership: '공유 (송창래 외)', landUse: '대지' },
  { parcel: '1302-3', area: 30.4, price: 20880000, total: 6.3, ownership: '윤정엽 (단독)', landUse: '대지' },
  { parcel: '1302-12', area: 320.9, price: 8892000, total: 28.5, ownership: '집합건물 (다수)', landUse: '대지' },
  { parcel: '1302-13', area: 308.2, price: 21230000, total: 65.4, ownership: '공유 (송창래 외)', landUse: '대지' },
  { parcel: '1302-18', area: 8.4, price: 23350000, total: 2.0, ownership: '집합건물 (다수)', landUse: '대지' },
  { parcel: '1302-19', area: 4.1, price: 23350000, total: 1.0, ownership: '집합건물 (다수)', landUse: '대지' },
];

// 총 사업비: 7,756억 (토지 2,755 + 공사 3,509 + 판매/금융/기타 1,492)
const costBreakdown = [
  { category: '토지 매입비', amount: 2755.0, ratio: 35.5, icon: 'ri-landscape-line', color: 'bg-teal-500', detail: '취등록세 및 제세공과금 포함' },
  { category: '건축공사비 (지상)', amount: 1980.0, ratio: 25.5, icon: 'ri-building-2-line', color: 'bg-emerald-500', detail: '지상 골조·마감·외장 공사' },
  { category: '건축공사비 (지하)', amount: 980.0, ratio: 12.6, icon: 'ri-building-line', color: 'bg-cyan-500', detail: '지하 10층 굴착·구조 공사' },
  { category: '특수시설 공사비', amount: 549.0, ratio: 7.1, icon: 'ri-tools-line', color: 'bg-sky-500', detail: '기계·전기·통신·소방 설비' },
  { category: '설계 및 감리비', amount: 155.0, ratio: 2.0, icon: 'ri-draft-line', color: 'bg-violet-500', detail: '건축설계, 감리용역, 인허가 대행' },
  { category: '인허가 및 부담금', amount: 320.0, ratio: 4.1, icon: 'ri-file-list-3-line', color: 'bg-amber-500', detail: '교통유발·학교용지·기반시설 부담금' },
  { category: 'PF 금융비용', amount: 480.0, ratio: 6.2, icon: 'ri-bank-line', color: 'bg-rose-400', detail: '프로젝트 파이낸싱 이자 및 수수료' },
  { category: '마케팅 및 분양비', amount: 312.0, ratio: 4.0, icon: 'ri-megaphone-line', color: 'bg-pink-400', detail: '분양 마케팅, 모델하우스, 광고비' },
  { category: '일반관리비 및 예비비', amount: 225.0, ratio: 2.9, icon: 'ri-shield-line', color: 'bg-gray-400', detail: '사업관리비, 예비비 5% 포함' },
];

// 총 매출: 10,032억 (오피스텔 6,917 + 상업 1,647 + 기타)
const revenueBreakdown = [
  {
    category: 'A동 오피스텔 분양',
    units: '156세대',
    unitPrice: '평당 1.3~1.5억원',
    amount: 3458.0,
    ratio: 34.5,
    icon: 'ri-building-4-line',
    detail: '하이엔드 오피스텔, 전용 84~135㎡',
    sub: '3.3㎡당 평균 1.4억원',
  },
  {
    category: 'B동 오피스텔 분양',
    units: '155세대',
    unitPrice: '평당 1.3~1.5억원',
    amount: 3459.0,
    ratio: 34.5,
    icon: 'ri-building-3-line',
    detail: '하이엔드 오피스텔, 전용 84~135㎡',
    sub: '3.3㎡당 평균 1.4억원',
  },
  {
    category: '상업시설 (포디움)',
    units: '근린생활시설',
    unitPrice: '3.3㎡당 약 1.2억원',
    amount: 1647.0,
    ratio: 16.4,
    icon: 'ri-store-2-line',
    detail: '지하~지상 저층부 쇼핑몰',
    sub: '강남역 도보권 프리미엄 반영',
  },
  {
    category: '공공기여 / 기타',
    units: '복합화센터·도서관',
    unitPrice: '기부채납 반영',
    amount: 468.0,
    ratio: 4.7,
    icon: 'ri-government-line',
    detail: '지하시설 포함 150% 공공기여',
    sub: '용적률 인센티브 환산가치',
  },
];

const sensitivityData = [
  { scenario: '낙관적', priceChange: '+10%', costChange: '-5%', irr: '28.4%', npv: '3,142', roiMultiple: '2.24x', profit: '3,142', color: 'text-teal-600', bg: 'bg-teal-50', border: 'border-teal-200' },
  { scenario: '기본', priceChange: '0%', costChange: '0%', irr: '20.87%', npv: '2,275', roiMultiple: '1.29x', profit: '2,275', color: 'text-emerald-600', bg: 'bg-emerald-50', border: 'border-emerald-200' },
  { scenario: '보수적', priceChange: '-5%', costChange: '+5%', irr: '14.2%', npv: '1,520', roiMultiple: '1.20x', profit: '1,520', color: 'text-amber-600', bg: 'bg-amber-50', border: 'border-amber-200' },
  { scenario: '비관적', priceChange: '-10%', costChange: '+10%', irr: '7.6%', npv: '680', roiMultiple: '1.09x', profit: '680', color: 'text-rose-500', bg: 'bg-rose-50', border: 'border-rose-200' },
];

const tabs = [
  { id: 'overview', label: '핵심 지표', icon: 'ri-dashboard-line' },
  { id: 'cost', label: '사업비 구조', icon: 'ri-money-dollar-circle-line' },
  { id: 'revenue', label: '수입 분석', icon: 'ri-line-chart-line' },
  { id: 'sensitivity', label: '민감도 분석', icon: 'ri-bar-chart-grouped-line' },
];

const TOTAL_REVENUE = 10032.31;
const TOTAL_COST = 7756.0;
const NET_PROFIT = 2275.0;
const PROFIT_RATE = 20.87;

export default function FeasibilityAnalysis() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <section id="feasibility" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-teal-100 text-teal-700 text-xs font-bold rounded-full mb-4 tracking-widest uppercase">FAR 743.04%</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">서초동 하이엔드 복합개발 수지분석</h2>
          <p className="text-lg text-gray-500 max-w-3xl mx-auto">
            지구단위계획 종상향 및 인센티브 적용으로 용적률 743.04% 확보.<br />
            총 매출 <strong className="text-gray-700">약 1조 원</strong>, 세전 사업 수익률 <strong className="text-teal-600">20.87%</strong> 달성 구조.
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex bg-white rounded-full p-1 shadow-sm border border-gray-100 gap-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-teal-600 text-white shadow-md'
                    : 'text-gray-500 hover:text-teal-600'
                }`}
              >
                <i className={`${tab.icon} mr-1.5 text-base`}></i>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* ── OVERVIEW TAB ── */}
        {activeTab === 'overview' && (
          <div className="space-y-10">
            {/* KPI Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { label: '총 매출액', value: '1조 32억', sub: '₩1,003,231,020,000', icon: 'ri-money-dollar-circle-line', color: 'teal' },
                { label: '총 사업비', value: '7,756억', sub: '토지+공사+판매/금융', icon: 'ri-funds-line', color: 'gray' },
                { label: '세전 순이익', value: '2,275억', sub: '사업 수익률 20.87%', icon: 'ri-exchange-funds-line', color: 'emerald' },
                { label: '용적률 (FAR)', value: '743.04%', sub: '기본 600% → 종상향+인센티브', icon: 'ri-building-2-line', color: 'amber' },
              ].map((kpi, i) => (
                <div key={i} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-default group">
                  <div className={`w-12 h-12 bg-${kpi.color}-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-${kpi.color}-600 transition-colors`}>
                    <i className={`${kpi.icon} text-xl text-${kpi.color}-600 group-hover:text-white transition-colors`}></i>
                  </div>
                  <div className="text-2xl font-bold text-gray-900 mb-0.5">{kpi.value}</div>
                  <div className="text-xs text-gray-400">{kpi.label}</div>
                  <div className="text-xs text-gray-400 mt-1">{kpi.sub}</div>
                </div>
              ))}
            </div>

            {/* Project Overview Card */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-map-pin-2-line text-teal-500 mr-2"></i>사업 개요
              </h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  {[
                    { label: '위치', value: '서울시 서초구 서초동 1302 일원' },
                    { label: '규모', value: '지하 10층 ~ 지상 30층 (2개동)' },
                    { label: '용도', value: '하이엔드 오피스텔 311세대 + 근린생활시설(쇼핑몰)' },
                    { label: '용적률', value: '743.04% (기본 600% → 종상향 및 인센티브 적용)' },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-4 py-3 border-b border-gray-50 last:border-0">
                      <span className="text-sm text-gray-400 w-20 shrink-0 pt-0.5">{item.label}</span>
                      <span className="text-sm font-semibold text-gray-800">{item.value}</span>
                    </div>
                  ))}
                </div>
                <div className="space-y-4">
                  {[
                    { label: '특화 가산', value: '디자인 110% 가산 + 친환경 인증 35% 가산' },
                    { label: '공공기여', value: '지하시설 포함 150% 공공기여 반영' },
                    { label: '분양가', value: '평당 1.3~1.5억원 (하이엔드 특화)' },
                    { label: '손익분기', value: '분양률 62% 달성 시 BEP 도달' },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-4 py-3 border-b border-gray-50 last:border-0">
                      <span className="text-sm text-gray-400 w-20 shrink-0 pt-0.5">{item.label}</span>
                      <span className="text-sm font-semibold text-gray-800">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Revenue vs Cost Bar */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-8">수지 요약</h3>
              <div className="space-y-6">
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-medium text-gray-600">총 사업비</span>
                    <span className="text-sm font-bold text-gray-900">{TOTAL_COST.toLocaleString()}억원</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-5 overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-gray-400 to-gray-500 rounded-full transition-all duration-1000" style={{ width: `${(TOTAL_COST / TOTAL_REVENUE * 100).toFixed(1)}%` }}></div>
                  </div>
                  <div className="text-right text-xs text-gray-400 mt-1">{(TOTAL_COST / TOTAL_REVENUE * 100).toFixed(1)}%</div>
                </div>
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-medium text-gray-600">총 매출액</span>
                    <span className="text-sm font-bold text-teal-600">{TOTAL_REVENUE.toLocaleString()}억원</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-5 overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-teal-400 to-teal-600 rounded-full" style={{ width: '100%' }}></div>
                  </div>
                  <div className="text-right text-xs text-gray-400 mt-1">100%</div>
                </div>
                <div className="pt-5 border-t border-gray-100 flex justify-between items-center">
                  <div>
                    <span className="text-lg font-bold text-gray-900">세전 순이익</span>
                    <span className="ml-3 text-sm text-gray-400">사업 수익률 {PROFIT_RATE}%</span>
                  </div>
                  <span className="text-3xl font-bold text-teal-600">{NET_PROFIT.toLocaleString()}억원</span>
                </div>
              </div>
            </div>

            {/* Strategic Value */}
            <div className="grid md:grid-cols-3 gap-6">
              {[
                {
                  icon: 'ri-arrow-up-circle-line',
                  color: 'teal',
                  title: '종상향 시나리오',
                  desc: '지구단위계획 변경을 통한 용적률 극대화(743%)로 사업성 대폭 개선. 기본 600% 대비 143%p 추가 확보.',
                },
                {
                  icon: 'ri-community-line',
                  color: 'emerald',
                  title: '공공기여 모델',
                  desc: '지하시설 포함 150% 공공기여 반영으로 지역 상생과 인센티브 동시 확보. 복합화센터·도서관 기부채납.',
                },
                {
                  icon: 'ri-vip-crown-line',
                  color: 'amber',
                  title: '하이엔드 특화',
                  desc: '최고급 오피스텔 분양가 평당 1.3~1.5억원 설정. 디자인 110% + 친환경 35% 가산으로 고수익 구조 실현.',
                },
              ].map((item, i) => (
                <div key={i} className={`bg-white rounded-2xl p-7 shadow-sm border border-gray-100 hover:shadow-lg transition-all`}>
                  <div className={`w-12 h-12 bg-${item.color}-100 rounded-xl flex items-center justify-center mb-4`}>
                    <i className={`${item.icon} text-xl text-${item.color}-600`}></i>
                  </div>
                  <h4 className="text-base font-bold text-gray-900 mb-2">{item.title}</h4>
                  <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── COST TAB ── */}
        {activeTab === 'cost' && (
          <div className="space-y-10">
            {/* Land Cost Table */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="px-8 py-6 border-b border-gray-100 flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-bold text-gray-900">필지별 토지 매입비 추정</h3>
                  <p className="text-sm text-gray-400 mt-1">2024년 공시지가 기준, 실거래 프리미엄 반영</p>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-teal-600">2,755억원</div>
                  <div className="text-xs text-gray-400">취등록세 및 제세공과금 포함</div>
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="text-left px-8 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wide">지번</th>
                      <th className="text-left px-4 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wide">지목</th>
                      <th className="text-right px-4 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wide">면적 (㎡)</th>
                      <th className="text-right px-4 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wide">공시지가 (원/㎡)</th>
                      <th className="text-left px-4 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wide">소유구조</th>
                      <th className="text-right px-8 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wide">추정 매입가 (억원)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {landCostData.map((item, index) => (
                      <tr key={index} className="border-t border-gray-50 hover:bg-gray-50/60 transition-colors">
                        <td className="px-8 py-4 text-sm font-semibold text-gray-900">{item.parcel}</td>
                        <td className="px-4 py-4 text-sm text-gray-500">{item.landUse}</td>
                        <td className="text-right px-4 py-4 text-sm text-gray-600">{item.area.toLocaleString()}</td>
                        <td className="text-right px-4 py-4 text-sm text-gray-600">{item.price.toLocaleString()}</td>
                        <td className="px-4 py-4 text-sm text-gray-500">{item.ownership}</td>
                        <td className="text-right px-8 py-4 text-sm font-bold text-gray-900">{item.total.toFixed(1)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="border-t-2 border-gray-200 bg-teal-50/60">
                      <td className="px-8 py-4 text-sm font-bold text-gray-900" colSpan={2}>합계</td>
                      <td className="text-right px-4 py-4 text-sm font-bold text-gray-900">
                        {landCostData.reduce((s, i) => s + i.area, 0).toLocaleString()}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-400">—</td>
                      <td className="px-4 py-4 text-sm text-gray-400">—</td>
                      <td className="text-right px-8 py-4 text-sm font-bold text-teal-600">
                        {landCostData.reduce((s, i) => s + i.total, 0).toFixed(1)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="px-8 py-4 bg-amber-50 border-t border-amber-100">
                <p className="text-sm text-amber-700">
                  <i className="ri-information-line mr-1"></i>
                  실거래 프리미엄(공시지가 대비 약 1.0~1.3배) 및 명도비용 포함 추정치. 취등록세·제세공과금 합산 시 총 2,755억원.
                </p>
              </div>
            </div>

            {/* Cost Breakdown */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <div className="flex items-center justify-between mb-8">
                <h3 className="text-xl font-bold text-gray-900">총 사업비 구성</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-gray-900">7,756억원</div>
                  <div className="text-xs text-gray-400">토지 2,755 + 공사 3,509 + 기타 1,492</div>
                </div>
              </div>
              <div className="space-y-5">
                {costBreakdown.map((item, index) => (
                  <div key={index}>
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        {/* Fixed the invalid Tailwind class syntax by using bg-opacity utility */}
                        <div className={`w-9 h-9 ${item.color} bg-opacity-10 rounded-lg flex items-center justify-center mr-3`}>
                          <i className={`${item.icon} text-base ${item.color.replace('bg-', 'text-')}`}></i>
                        </div>
                        <div>
                          <span className="text-sm font-semibold text-gray-700">{item.category}</span>
                          <span className="text-xs text-gray-400 ml-2">{item.detail}</span>
                        </div>
                      </div>
                      <div className="text-right shrink-0 ml-4">
                        <span className="text-sm font-bold text-gray-900">{item.amount.toLocaleString()}억원</span>
                        <span className="text-xs text-gray-400 ml-1.5">({item.ratio}%)</span>
                      </div>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
                      <div className={`h-full ${item.color} rounded-full transition-all duration-700`} style={{ width: `${item.ratio * 2.5}%` }}></div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-8 pt-6 border-t border-gray-100 grid grid-cols-3 gap-4">
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-400 mb-1">토지비</div>
                  <div className="text-xl font-bold text-gray-900">2,755억</div>
                  <div className="text-xs text-teal-600 mt-0.5">35.5%</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-400 mb-1">공사비</div>
                  <div className="text-xl font-bold text-gray-900">3,509억</div>
                  <div className="text-xs text-teal-600 mt-0.5">45.2%</div>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="text-xs text-gray-400 mb-1">판매/금융/기타</div>
                  <div className="text-xl font-bold text-gray-900">1,492억</div>
                  <div className="text-xs text-teal-600 mt-0.5">19.2%</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── REVENUE TAB ── */}
        {activeTab === 'revenue' && (
          <div className="space-y-10">
            {/* Revenue Cards */}
            <div className="grid md:grid-cols-2 gap-6">
              {revenueBreakdown.map((item, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-lg transition-all cursor-default group">
                  <div className="flex items-start justify-between mb-5">
                    <div className="w-13 h-13 w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center group-hover:bg-teal-600 transition-colors">
                      <i className={`${item.icon} text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
                    </div>
                    <div className="text-right">
                      <div className="text-3xl font-bold text-gray-900">{item.amount.toLocaleString()}<span className="text-base font-medium text-gray-400 ml-1">억</span></div>
                      <div className="text-sm text-teal-600 font-semibold">{item.ratio}%</div>
                    </div>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">{item.category}</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-400">규모</span>
                      <span className="text-gray-700 font-medium">{item.units}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-400">단가</span>
                      <span className="text-gray-700 font-medium">{item.unitPrice}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-400">비고</span>
                      <span className="text-gray-700 font-medium">{item.sub}</span>
                    </div>
                  </div>
                  <div className="mt-4 w-full bg-gray-100 rounded-full h-2 overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-teal-400 to-teal-600 rounded-full" style={{ width: `${item.ratio * 1.05}%` }}></div>
                  </div>
                </div>
              ))}
            </div>

            {/* Revenue Summary */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6">매출 구조 요약</h3>
              <div className="grid md:grid-cols-4 gap-5 mb-8">
                {[
                  { label: '총 매출액', value: '1조 32억', sub: '₩1,003,231,020,000', color: 'teal' },
                  { label: 'A+B동 오피스텔', value: '6,917억', sub: '311세대 합계', color: 'emerald' },
                  { label: '상업시설 (포디움)', value: '1,647억', sub: '근린생활시설', color: 'amber' },
                  { label: '손익분기 분양률', value: '62%', sub: 'BEP 달성 기준', color: 'rose' },
                ].map((s, i) => (
                  <div key={i} className={`text-center p-5 bg-${s.color}-50 rounded-xl`}>
                    <div className="text-xs text-gray-400 mb-1">{s.label}</div>
                    <div className={`text-2xl font-bold text-${s.color}-600`}>{s.value}</div>
                    <div className="text-xs text-gray-400 mt-1">{s.sub}</div>
                  </div>
                ))}
              </div>
              <div className="p-6 bg-gray-50 rounded-xl">
                <h4 className="text-sm font-bold text-gray-700 mb-3">
                  <i className="ri-lightbulb-line mr-1 text-amber-500"></i>수입 전망 근거
                </h4>
                <ul className="space-y-2 text-sm text-gray-600">
                  {[
                    '서초동 신축 하이엔드 오피스텔 실거래가 3.3㎡당 1.3~1.5억원 (2024년 기준)',
                    '강남역 도보권 상업시설 분양가 3.3㎡당 1.0~1.5억원 수준',
                    '디자인 110% + 친환경 35% 가산 적용으로 분양가 상한 극대화',
                    '지하시설 포함 150% 공공기여로 용적률 인센티브 확보, 사업성 추가 개선',
                    '롯데칠성 부지 등 인근 대형 개발 호재로 지가 상승 기대',
                  ].map((t, i) => (
                    <li key={i} className="flex items-start">
                      <i className="ri-check-line text-teal-500 mr-2 mt-0.5 shrink-0"></i>{t}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}

        {/* ── SENSITIVITY TAB ── */}
        {activeTab === 'sensitivity' && (
          <div className="space-y-10">
            {/* Scenario Cards */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
              {sensitivityData.map((item, index) => (
                <div key={index} className={`${item.bg} rounded-2xl p-6 border ${item.border} hover:shadow-lg transition-all cursor-default`}>
                  <div className={`text-xs font-bold ${item.color} mb-4 uppercase tracking-widest`}>{item.scenario} 시나리오</div>
                  <div className="space-y-4">
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">분양가 변동</div>
                      <div className="text-lg font-bold text-gray-900">{item.priceChange}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">공사비 변동</div>
                      <div className="text-lg font-bold text-gray-900">{item.costChange}</div>
                    </div>
                    <div className="pt-4 border-t border-gray-200/60">
                      <div className="text-xs text-gray-400 mb-0.5">사업 수익률 (IRR)</div>
                      <div className={`text-3xl font-bold ${item.color}`}>{item.irr}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">세전 순이익</div>
                      <div className="text-lg font-bold text-gray-900">{item.npv}억원</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">투자 배수</div>
                      <div className={`text-lg font-bold ${item.color}`}>{item.roiMultiple}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Risk & Mitigation */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-8">주요 리스크 요인 및 대응 전략</h3>
              <div className="grid md:grid-cols-2 gap-6">
                {[
                  {
                    icon: 'ri-error-warning-line', color: 'rose',
                    title: '토지 매입 리스크',
                    desc: '집합건물 구분소유자 협상 지연 및 알박기 가능성',
                    action: '매도청구권 법적 토대 구축, SPC 주주 참여 제안, 단계별 매입 전략',
                  },
                  {
                    icon: 'ri-funds-line', color: 'amber',
                    title: '금리 변동 리스크',
                    desc: 'PF 금리 상승 시 금융비용 증가 (±1%p당 약 48억원)',
                    action: '고정금리 PF 확보, 분양 선수금 조기 확보, 시공사 책임준공 확약',
                  },
                  {
                    icon: 'ri-building-line', color: 'violet',
                    title: '공사비 상승 리스크',
                    desc: '원자재 가격 상승 및 인건비 증가 추세 (지하 10층 심층 굴착 리스크)',
                    action: '도급계약 물가변동 조항 제한, 예비비 5% 확보, VE 설계 적용',
                  },
                  {
                    icon: 'ri-home-line', color: 'cyan',
                    title: '분양 시장 리스크',
                    desc: '부동산 시장 침체 시 분양률 저하 가능성 (BEP 62% 유지 필요)',
                    action: '하이엔드 차별화 전략, 조기 분양 마케팅, 임대 전환 옵션 확보',
                  },
                  {
                    icon: 'ri-file-list-3-line', color: 'emerald',
                    title: '인허가 지연 리스크',
                    desc: '지구단위계획 변경 및 종상향 심의 지연 가능성',
                    action: '사전 행정 협의 강화, 공공기여 협상 조기 착수, 병행 인허가 추진',
                  },
                  {
                    icon: 'ri-government-line', color: 'gray',
                    title: '정책 변동 리스크',
                    desc: '오피스텔 규제 강화 또는 분양가 상한제 적용 가능성',
                    action: '용도 다변화 설계 검토, 법인 임대 전환 시나리오 사전 준비',
                  },
                ].map((item, i) => (
                  <div key={i} className={`p-6 bg-${item.color}-50 rounded-xl border border-${item.color}-100`}>
                    <div className="flex items-center mb-3">
                      <div className={`w-10 h-10 bg-${item.color}-100 rounded-lg flex items-center justify-center mr-3`}>
                        <i className={`${item.icon} text-xl text-${item.color}-500`}></i>
                      </div>
                      <h4 className="text-sm font-bold text-gray-900">{item.title}</h4>
                    </div>
                    <p className="text-sm text-gray-600 mb-3">{item.desc}</p>
                    <div className="text-sm text-teal-700 bg-teal-50 rounded-lg p-3">
                      <strong>대응:</strong> {item.action}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Timeline */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-8">사업 추진 일정 및 현금흐름</h3>
              <div className="relative">
                <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gray-200"></div>
                <div className="space-y-6">
                  {[
                    { phase: '1단계', period: '2025.Q1 ~ Q4', title: '토지 매입 및 인허가', cashflow: '-2,755억 (토지)', detail: '필지 매입, 환경영향평가, 지구단위계획 변경, 건축허가', color: 'bg-rose-400' },
                    { phase: '2단계', period: '2026.Q1 ~ Q2', title: '착공 및 분양 개시', cashflow: '-480억 / +2,000억', detail: '착공, 모델하우스 오픈, 1차 분양 (계약금 수납)', color: 'bg-amber-400' },
                    { phase: '3단계', period: '2026.Q3 ~ 2028.Q2', title: '본공사 및 중도금 수납', cashflow: '-3,509억 / +5,200억', detail: '지하·지상 공사, 2차 분양, 중도금 수납', color: 'bg-teal-400' },
                    { phase: '4단계', period: '2028.Q3 ~ Q4', title: '준공 및 입주', cashflow: '+2,832억 (잔금)', detail: '준공검사, 입주, 잔금 수납, 상업시설 오픈', color: 'bg-emerald-500' },
                  ].map((item, index) => (
                    <div key={index} className="relative pl-16">
                      <div className={`absolute left-4 w-5 h-5 ${item.color} rounded-full border-4 border-white shadow-sm`}></div>
                      <div className="bg-gray-50 rounded-xl p-5 hover:shadow-md transition-all">
                        <div className="flex flex-wrap items-center gap-2 mb-2">
                          <span className={`px-3 py-1 ${item.phase.startsWith('1') ? 'bg-rose-400' : item.phase.startsWith('2') ? 'bg-amber-400' : item.phase.startsWith('3') ? 'bg-teal-400' : 'bg-emerald-500'} text-white text-xs font-bold rounded-full`}>{item.phase}</span>
                          <span className="text-sm text-gray-400">{item.period}</span>
                        </div>
                        <h4 className="text-base font-bold text-gray-900 mb-1">{item.title}</h4>
                        <p className="text-sm text-gray-500 mb-2">{item.detail}</p>
                        <div className="text-sm font-bold text-teal-600">{item.cashflow}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Bottom CTA */}
        <div className="mt-16 bg-gradient-to-r from-teal-600 to-emerald-600 rounded-2xl p-10 text-center text-white">
          <i className="ri-bar-chart-box-line text-5xl mb-4"></i>
          <h3 className="text-2xl font-bold mb-4">투자 상담 및 상세 사업계획서 요청</h3>
          <p className="text-lg text-teal-100 max-w-2xl mx-auto mb-6">
            본 수지 분석은 보수적 추정 기준으로 작성되었습니다.<br />
            상세 사업계획서 및 투자 상담은 아래 버튼을 통해 신청해 주세요.
          </p>
          <button
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) {
                const offset = 80;
                const pos = el.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: pos, behavior: 'smooth' });
              }
            }}
            className="bg-white text-teal-700 px-8 py-4 rounded-lg font-bold hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
          >
            투자 상담 신청하기
          </button>
        </div>
      </div>
    </section>
  );
}
